export default function TrustBar() {
    const items = [
        "Bygget til den danske rengøringsbranche",
        "GDPR-compliant",
        "Hostet i EU",
        "Integration med e-conomic & Dinero",
        "Mobil-first for kørende personale",
        "API på vej",
    ];
    const looped = [...items, ...items];
    return (
        <section className="py-10 border-y border-slate-200/70 bg-white" data-testid="trustbar">
            <div className="overflow-hidden relative">
                <div className="flex gap-12 animate-marquee whitespace-nowrap">
                    {looped.map((t, i) => (
                        <div key={i} className="flex items-center gap-3 text-slate-500 text-sm font-medium">
                            <span className="h-1.5 w-1.5 rounded-full bg-sky-500" />
                            {t}
                        </div>
                    ))}
                </div>
                <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
            </div>
        </section>
    );
}
